if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        if (this.isCompareBarShowing()) {
          this.hide();
        } else {
          this.show();
        }

        this.lastScrollTop = 0;
        this.scrollHandler = FoxTheme.utils.debounce(this.onScrollHandler.bind(this), 10);
        this.init();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
      }

      init() {
        this.calculateHeight();
        window.addEventListener('scroll', this.scrollHandler, false);
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      onScrollHandler() {
        if (this.isCompareBarShowing()) {
          this.hide();
          return;
        }

        if (document.querySelector('mareld-styleberater')) {
          this.updateAdvisorBar();
          return;
        }

        const offsetTop = document.getElementById('mobileNavStatic').offsetTop;
        const scrollTop = window.scrollY;
        const pointTouch = offsetTop - scrollTop - window.innerHeight;

        requestAnimationFrame(() => {
          this.scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';
          this.lastScrollTop = scrollTop;

          if (this.scrollDirection == 'up' && pointTouch > 0) {
            this.show();
          } else {
            this.hide();
          }
        });
      }

      updateAdvisorBar() {
        const marker = document.getElementById('mobileNavStatic');
        const scroller = document.scrollingElement;
        if (!marker || !scroller) return;

        // Ignore elastic overscroll and repeated or subpixel scroll positions.
        const maxScroll = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
        const scrollTop = Math.min(maxScroll, Math.max(0, window.scrollY));
        const previousTop = Math.min(maxScroll, this.lastScrollTop);
        const delta = scrollTop - previousTop;
        if (Math.abs(delta) < 2) return;
        this.lastScrollTop = scrollTop;

        const beforeFooter = marker.getBoundingClientRect().top > window.innerHeight;
        const shouldShow = delta < 0 && beforeFooter;
        if (shouldShow === document.body.classList.contains(this.classes.isShow)) return;

        if (shouldShow) {
          this.show();
        } else {
          this.hide();
        }
      }

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        document.body.classList.remove(this.classes.isShow);
        document.body.classList.add(this.classes.isHide);
      }
    }
  );
}
